import { render, staticRenderFns } from "./OrganisationView.vue?vue&type=template&id=69df05ce"
import script from "./OrganisationView.vue?vue&type=script&lang=js"
export * from "./OrganisationView.vue?vue&type=script&lang=js"
import style0 from "./OrganisationView.vue?vue&type=style&index=0&id=69df05ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports